import type { InjectionKey } from 'vue'

export function injectionKey <T> (key: string): InjectionKey<T> {
  return Symbol(key)
}
